import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LoanApprovalComponent } from '../../authenticated/pages/loan-approval/loan-approval.component';
import { Loan } from '@akiba/models_bimbo';

@Component({
  selector: 'app-reject-dialog',
  templateUrl: './reject-dialog.component.html',
  styleUrls: ['./reject-dialog.component.scss']
})
export class RejectDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LoanApprovalComponent>, @Inject(MAT_DIALOG_DATA) public data: Loan) {

  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.data.comment = '';
    this.dialogRef.close();
  }

}
